import { defineStore } from "pinia";

export const useDataStore = defineStore("data", {
  state: () => ({
    data: [], // always one set of data, updated by requestManager
  }),
  actions: {
    setData(newData) {
      this.data = newData;
    },
    updateOrMerge(newItems) {
      // Replace existing items by id, or add new ones
      const map = new Map(this.data.map((item) => [item.id, item]));
      newItems.forEach((item) => map.set(item.id, item));
      this.data = Array.from(map.values());
    },
  },
  getters: {
    getById: (state) => {
      return (id) => state.data.find((item) => String(item.id) === String(id));
    },
  },
});
